import * as React from 'react';
import { getStyleHookProps } from './getStyleHookProps';
import { resolveClassName } from './resolveClassName';
import { evaluateRenderProp } from './evaluateRenderProp';
import { useRenderPropForkRef } from './useRenderPropForkRef';
import { defaultRenderFunctions } from './defaultRenderFunctions';
/**
 * Returns a function that renders a Base UI component.
 *
 * @ignore - internal hook.
 */
export function useComponentRenderer(settings) {
  const {
    render: renderProp,
    className: classNameProp,
    ownerState,
    ref,
    propGetter = props => props,
    extraProps,
    customStyleHookMapping
  } = settings;
  const className = resolveClassName(classNameProp, ownerState);
  const styleHooks = React.useMemo(() => {
    return getStyleHookProps(ownerState, customStyleHookMapping);
  }, [ownerState, customStyleHookMapping]);
  const ownProps = {
    ...styleHooks,
    ...extraProps,
    className
  };
  let resolvedRenderProp;
  if (typeof renderProp === 'string') {
    resolvedRenderProp = defaultRenderFunctions[renderProp];
  } else {
    resolvedRenderProp = renderProp;
  }
  const renderedElementProps = propGetter(ownProps);
  const propsWithRef = {
    ...renderedElementProps,
    ref: useRenderPropForkRef(resolvedRenderProp, ref, renderedElementProps.ref)
  };
  const renderElement = () => evaluateRenderProp(resolvedRenderProp, propsWithRef, ownerState);
  return {
    renderElement
  };
}